import { render, staticRenderFns } from "./ShareholderBlock.vue?vue&type=template&id=3cb4938e"
import script from "./ShareholderBlock.vue?vue&type=script&lang=js"
export * from "./ShareholderBlock.vue?vue&type=script&lang=js"
import style0 from "./ShareholderBlock.vue?vue&type=style&index=0&id=3cb4938e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports